import React, { useState } from 'react';
import ModalPortal from './ModalPortal';

interface GenericAddModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: Record<string, string>) => void;
  title?: string;
}

const GenericAddModal: React.FC<GenericAddModalProps> = ({ 
  isOpen, 
  onClose, 
  onSave, 
  title = 'Add New Item' 
}) => {
  const [formData, setFormData] = useState({
    label1: '',
    label2: 'option1',
    label3: new Date().toISOString().split('T')[0],
    label4: 'active'
  });

  const handleSave = () => {
    if (formData.label1.trim()) {
      onSave(formData);
      handleClose();
    }
  };

  const handleClose = () => {
    setFormData({
      label1: '',
      label2: 'option1',
      label3: new Date().toISOString().split('T')[0],
      label4: 'active'
    });
    onClose();
  };

  return (
    <ModalPortal isOpen={isOpen} onClose={handleClose} size="small">
      <div className="modal-header">
        <h3>{title}</h3>
        <button 
          className="modal-close-button" 
          onClick={handleClose}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <div className="form-container">
          <div className="form-group">
            <label>Label1 - Text Input</label>
            <input 
              type="text" 
              value={formData.label1}
              onChange={(e) => setFormData({...formData, label1: e.target.value})}
              className="form-input"
              placeholder="Enter text value"
            />
          </div>
          <div className="form-group">
            <label>Label2 - Dropdown</label>
            <select 
              value={formData.label2}
              onChange={(e) => setFormData({...formData, label2: e.target.value})}
              className="form-select"
            >
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
              <option value="option4">Option 4</option>
            </select>
          </div>
          <div className="form-group">
            <label>Label3 - Date Picker</label>
            <input 
              type="date" 
              value={formData.label3}
              onChange={(e) => setFormData({...formData, label3: e.target.value})}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Label4 - Status</label>
            <select 
              value={formData.label4}
              onChange={(e) => setFormData({...formData, label4: e.target.value})}
              className="form-select"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="draft">Draft</option>
              <option value="review">Review</option>
            </select>
          </div>
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn-secondary" onClick={handleClose}>
          Cancel
        </button>
        <button 
          className="btn-primary" 
          onClick={handleSave}
        >
          Save Item
        </button>
      </div>
    </ModalPortal>
  );
};

export default GenericAddModal;